<template>
    <div :class="'wrapper sidebar-mini ' + sidebar">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_back"/>
        </template>

        <HeaderComponent v-on:collapse="collapse"/>

        <AsideComponent :sidebar="sidebar" v-on:collapse="collapse"/>

        <div class="content-wrapper" @click="restore">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </div>

        <FooterComponent/>

        <ModalCuentaAtrasCarrito @close="close('carrito-terminado')"/>
        <ModalCuentraAtrasAvisoCarrito :secondsLeft="carrito?.seconds_left" @close="close('carrito-aviso')"/>
    </div>
</template>

<script>
    import FooterComponent from '@/components/backend/footer/FooterComponent';
    import HeaderComponent from '@/components/backend/header/HeaderComponent';
    import AsideComponent from '@/components/backend/aside/AsideComponent';
    import LoadCssComponent from  '@/components/css/LoadCssComponent';
    import ModalCuentaAtrasCarrito from '../../components/common/carrito/ModalCuentaAtrasCarrito.vue';
    import ModalCuentraAtrasAvisoCarrito from '../../components/common/carrito/ModalCuentraAtrasAvisoCarrito.vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useAdminAssets } from '@/composables/admin/assets/useAdminAssets';

    export default {
        data() {
            return {
                sidebar: ''
            }
        },
        created() {
            useHead('Admin');
            useAdminAssets();
        },
        watch: {
            'carrito.seconds_left': function(newVal) {
                if (newVal === 0) {
                    this.$modal.show('carrito-terminado');
                    this.$router.push({ path: '/admin/eventos' });
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            },
        },
        methods: {
            collapse() {
                if(this.sidebar == '') {
                    this.sidebar = 'sidebar-collapse sidebar-open';
                } else {
                    this.sidebar = '';
                }
            },
            restore() {
                this.sidebar = '';
            },
            close(modal) {
                this.$modal.hide(modal);
            },
        },
        components: {
            FooterComponent, HeaderComponent, AsideComponent, LoadCssComponent, ModalCuentaAtrasCarrito, ModalCuentraAtrasAvisoCarrito
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
